var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "signup el-reset" },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
        [
          _vm.isUpdating
            ? _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { sm: 12 } }, [
                    _c(
                      "label",
                      {
                        staticClass: "input-file",
                        on: {
                          click: function ($event) {
                            return _vm.handlePopupPhotoEditor("profile")
                          },
                        },
                      },
                      [
                        _vm.profileUrl
                          ? _c("i-avatar", { attrs: { url: _vm.profileUrl } })
                          : _c("div", {
                              staticClass: "empty circle",
                              domProps: { textContent: _vm._s("+") },
                            }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("general.editProfileImg"))),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { sm: 12 } }, [
                    _c(
                      "label",
                      {
                        staticClass: "input-file",
                        on: {
                          click: function ($event) {
                            return _vm.handlePopupPhotoEditor("coverPhoto")
                          },
                        },
                      },
                      [
                        _vm.coverPhotoUrl
                          ? _c("img", {
                              staticClass: "rectangle",
                              attrs: { src: _vm.coverPhotoUrl },
                            })
                          : _c("div", {
                              staticClass: "empty rectangle",
                              domProps: { textContent: _vm._s("+") },
                            }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("general.editCoverImg"))),
                        ]),
                      ]
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { sm: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "email",
                        label: _vm.$t("email"),
                        "label-position": "top",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: _vm.$t("email") },
                        model: {
                          value: _vm.form.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "email", $$v)
                          },
                          expression: "form.email",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { sm: 12 } },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEmailHintShow,
                          expression: "isEmailHintShow",
                        },
                      ],
                      staticClass: "email-hint",
                    },
                    [_vm._v(_vm._s(_vm.$t("vrlounge.cannotChangeAfterSubmit")))]
                  ),
                  _vm._v(" "),
                  _vm.isCreating
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "confirmEmail",
                            label: _vm.$t("general.confirmEmail"),
                            "label-position": "top",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("general.confirmEmail"),
                            },
                            on: {
                              focus: function ($event) {
                                _vm.isEmailHintShow = true
                              },
                              blur: function ($event) {
                                _vm.isEmailHintShow = false
                              },
                            },
                            model: {
                              value: _vm.form.confirmEmail,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "confirmEmail", $$v)
                              },
                              expression: "form.confirmEmail",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isUpdating
                    ? _c("el-form-item", {
                        attrs: {
                          label: _vm.$t("general.password"),
                          "label-position": "top",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isUpdating
                    ? _c(
                        "el-link",
                        {
                          staticClass: "change-password",
                          attrs: { type: "warning" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("to-change-password")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("general.changePassword")) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { sm: 12 } },
                [
                  _vm.isCreating
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "password",
                            label: _vm.$t("general.password"),
                            "label-position": "top",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              password: "",
                              "show-password": "",
                              placeholder: _vm.$t("general.password"),
                            },
                            model: {
                              value: _vm.form.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "password", $$v)
                              },
                              expression: "form.password",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { sm: 12 } },
                [
                  _vm.isCreating
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "confirmPassword",
                            label: _vm.$t("general.confirmPassword"),
                            "label-position": "top",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              password: "",
                              "show-password": "",
                              placeholder: _vm.$t("general.confirmPassword"),
                            },
                            model: {
                              value: _vm.form.confirmPassword,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "confirmPassword", $$v)
                              },
                              expression: "form.confirmPassword",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isUpdating
            ? _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { sm: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "firstName",
                            label: _vm.$t("firstName"),
                            "label-position": "top",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("firstName") },
                            model: {
                              value: _vm.form.firstName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "firstName", $$v)
                              },
                              expression: "form.firstName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { sm: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "lastName",
                            label: _vm.$t("lastName"),
                            "label-position": "top",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("lastName") },
                            model: {
                              value: _vm.form.lastName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "lastName", $$v)
                              },
                              expression: "form.lastName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isUpdating
            ? _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { sm: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "nickname",
                            label: _vm.$t("general.knownAs"),
                            "label-position": "top",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("general.knownAs") },
                            model: {
                              value: _vm.form.nickname,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "nickname", $$v)
                              },
                              expression: "form.nickname",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { sm: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "company",
                            label: _vm.$t("company"),
                            "label-position": "top",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("company") },
                            model: {
                              value: _vm.form.company,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "company", $$v)
                              },
                              expression: "form.company",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isUpdating
            ? _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { sm: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "position",
                            label: _vm.$t("general.position"),
                            "label-position": "top",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("general.position") },
                            model: {
                              value: _vm.form.position,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "position", $$v)
                              },
                              expression: "form.position",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { sm: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "phone",
                            label: _vm.$t("phone"),
                            "label-position": "top",
                          },
                        },
                        [
                          _c("vue-tel-input", {
                            staticClass: "phone-input",
                            attrs: { mode: "international" },
                            model: {
                              value: _vm.form.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "phone", $$v)
                              },
                              expression: "form.phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isUpdating
            ? _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { sm: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "country",
                            label: _vm.$t("location"),
                            "label-position": "top",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t("location"),
                                "no-match-text": "no result",
                                filterable: "",
                              },
                              model: {
                                value: _vm.form.country,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "country", $$v)
                                },
                                expression: "form.country",
                              },
                            },
                            _vm._l(
                              _vm.countryList,
                              function (country, isoCode) {
                                return _c("el-option", {
                                  key: isoCode,
                                  staticStyle: { "max-width": "100vw" },
                                  attrs: {
                                    label: `${country.en} ${country.ch}`,
                                    value: isoCode,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isCreating
            ? _c(
                "el-form-item",
                { attrs: { prop: "agree" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "overflow-x",
                      staticStyle: { "vertical-align": "text-top" },
                      model: {
                        value: _vm.form.agree,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "agree", $$v)
                        },
                        expression: "form.agree",
                      },
                    },
                    [
                      _c("el-link", { attrs: { type: "warning" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$i18n.locale === "zh-tw"
                                ? "隱私政策"
                                : "Privacy Policy"
                            ) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "signup__action" },
        [
          _c(
            "button",
            { staticClass: "el-button", on: { click: _vm.handleSubmit } },
            [_vm._v("\n      " + _vm._s(_vm.$t("Submit")) + "\n    ")]
          ),
          _vm._v(" "),
          _vm.isCreating
            ? _c(
                "el-link",
                {
                  attrs: { type: "warning" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("to-login")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("general.login")) + "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "i-modal",
        {
          ref: "cover-photo-editor-modal",
          attrs: { bgcolor: "rgba(0,0,0,0.7)", closeable: false },
        },
        [
          _c("cover-photo-editor", {
            attrs: {
              width: _vm.coverConfig.width,
              height: _vm.coverConfig.height,
              "border-radius": _vm.coverConfig.borderRadius,
              type: _vm.coverConfig.type,
            },
            on: { save: _vm.updateCoverImageUrl, close: _vm.closeModal },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "i-modal",
        {
          ref: "avatar-editor-modal",
          attrs: { bgcolor: "rgba(0,0,0,0.7)", closeable: false },
        },
        [_c("avatar-editor", { on: { close: _vm.closeModal } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }